import { createSlotRecipe } from './runtime';

const carouselConfig = {"name":"carousel","slots":["root","viewport","itemGroup","item","nextTrigger","prevTrigger","indicatorGroup","indicator","control"],"defaultVariants":{"size":"md"},"variantMap":{"size":["md","sm"]}}

export const carousel = /* @__PURE__ */ createSlotRecipe(carouselConfig)